import { useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import OtpInput from "react-otp-input";
import { toast } from "react-toastify";
import Spinner from "./Spinner";

const SignupOTP = ({ handleCloseOTPModal, token }) => {
  const [loading, setLoading] = useState(false);

  const [otp, setOtp] = useState("");
  const handleOTPSubmit = () => {
    const sendOTP = async () => {
      setLoading(true);
      // const token = localStorage.getItem("token");
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/customer/verify-otp`,
        {
          method: "PUT",
          //add token to headers
          headers: {
            "Content-Type": "application/json",
            "x-sh-auth": token,
          },
          body: JSON.stringify({ token, otp }),
        }
      );
      const data = await response.json();
      if (data.code === 400) {
        toast.error("OTP is incorrect");
        setLoading(false);
      } else if (data.code === 200) {
        toast.success("OTP is verified!");
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/auth/me`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "x-sh-auth": data.data.token,
            },
          }
        );
        setLoading(false);
        const user = await response.json();
        localStorage.setItem("token", data.data.token);
        localStorage.setItem("ID", user.detail._id);
        localStorage.setItem("username", user.detail.fullName);
        window.location.href = "/login";
      }
    };
    sendOTP();
  };
  return (
    <div
      className={`fixed inset-0 z-50 $
     flex items-center justify-center" 
    backdrop-blur-[3px] bg-black bg-opacity-20`}
    >
      <div className="flex flex-col items-center justify-center bg-white rounded-md sm:p-12 p-8 mx-auto">
        <div className="flex flex-row-reverse items-center justify-between w-full relative sm:bottom-10 bottom-5">
          {/* <AiOutlineClose
            className="text-primaryGreen cursor-pointer relative sm:left-9 left-5"
            size={30}
            onClick={handleCloseOTPModal}
          /> */}
        </div>
        <h3 className="text-3xl text-center mb-5">
          Enter One Time Password (OTP)
        </h3>
        <OtpInput
          value={otp}
          onChange={setOtp}
          numInputs={6}
          required
          inputStyle={{
            border: "2px solid #F66",
            borderRadius: 5,
            width: 40,
            height: 50,
            margin: 3,
            textAlign: "center",
            fontSize: 20,
            fontWeight: "bold",
            color: "#F66",
          }}
          renderSeparator={<span style={{ color: "#F66" }}>-</span>}
          renderInput={(props) => <input {...props} />}
          shouldAutoFocus
          placeholder="XXXXXX"
        />
        <div className="flex items-center justify-center gap-2">
          <button
            className="py-3 px-10 mt-5 border-2 bg-[#F66] text-white duration-150 ease-linear rounded-md hover:bg-primary-dark"
            onClick={handleOTPSubmit}
            disabled={loading}
          >
            {loading ? <Spinner size="43" /> : "Confirm"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SignupOTP;
